// EAA-1667: In-memory embed credential store, moved from web-content's embedApiToken
// util into the core auth module. It's app-agnostic — any app embedded in an iframe
// receives a token on load and holds it in memory for the session (never persisted).
// Two schemes are supported: a tenant access JWT (Authorization: Bearer, from
// token-exchange) and a legacy API token (Authorization: Token).

let embedApiToken: string | null = null;
let embedBearerToken: string | null = null;

/** Legacy API token (use with `Authorization: Token`). */
export function setEmbedApiToken(token: string | null): void {
    embedApiToken = token?.trim() || null;
}

export function getEmbedApiToken(): string | null {
    return embedApiToken;
}

/** Tenant access JWT from token-exchange (use with `Authorization: Bearer`). */
export function setEmbedBearerToken(token: string | null): void {
    embedBearerToken = token?.trim() || null;
}

export function getEmbedBearerToken(): string | null {
    return embedBearerToken;
}

/** Clear both embed credentials (e.g. on unmount / token expiry). */
export function clearEmbedApiToken(): void {
    embedApiToken = null;
    embedBearerToken = null;
}
